/*why*/
/*what-is-collected*/
/*how-do-i-opt-out*/
/*disable*/
/*status*/
/*enable*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "遥测",
  "description": "了解更多关于 Turborepo 的匿名遥测功能。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Vercel Inc.（Vercel）可能会收集有关你使用 Turborepo 的遥测数据，如下所述。遥测数据使我们能够通过收集有关 Turborepo 和 Vercel 平台使用情况和主机信息的匿名数据来监控和改进 Turborepo 和 Vercel 平台。这些数据可能用于广泛识别、排除故障或响应影响用户的问题。"
  }, {
    "heading": "",
    "content": "¥Vercel Inc. (Vercel) may collect telemetry data about your use of Turborepo as explained below.\nTelemetry data allows us to monitor and improve Turborepo and the Vercel platform by\ncollecting anonymous data about its usage and host information. The data may be used to broadly identify,\ntroubleshoot, or respond to issues that impact users."
  }, {
    "heading": "",
    "content": "遥测数据的收集是可选的。如果你不想收集遥测数据，你可以禁用 opt-out。"
  }, {
    "heading": "",
    "content": "¥Collection of telemetry data is optional. If you do not want telemetry data collected, you may opt-out."
  }, {
    "heading": "为什么-why",
    "content": "¥Why"
  }, {
    "heading": "为什么-why",
    "content": "遥测使我们能够准确衡量所有用户的 Turborepo 功能使用情况、痛点和自定义设置。这些数据使我们能够更好地根据大众需求定制 Turborepo，确保其持续增长、相关性和一流的开发者体验。此外，这些数据使我们能够验证改进是否正在改善所有应用的基准。"
  }, {
    "heading": "为什么-why",
    "content": "¥Telemetry allows us to accurately gauge Turborepo feature usage, pain points, and customization across all users.\nThis data enables us to better tailor Turborepo to the masses, ensuring its continued growth, relevance, and best-in-class developer experience.\nFurthermore, this data allows us to verify if improvements are improving the baseline of all applications."
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥What is collected"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "我们跟踪一般使用信息，具体来说，我们使用随机标识符通过匿名遥测数据跟踪以下内容："
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥We track general usage information, specifically, we track the following with anonymized telemetry data using random identifiers:"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "调用的命令（turbo run、turbo prune、turbo gen 等）"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥Command invoked (turbo run, turbo prune, turbo gen, etc.)"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "turbo 版本"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥Version of turbo"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "常规机器信息（例如 CPU 数量、macOS/Windows/Linux，以及命令是否在 CI 中运行）"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥General machine information (e.g. number of CPUs, macOS/Windows/Linux, whether or not the command was run within CI)"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "应用大小（工作区总数）"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥Size of application (total number of workspaces)"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "我们不会收集任何可能包含敏感数据的指标。这包括但不限于：任务名称、包名称、敏感参数或标志值、环境变量、文件路径或文件内容。"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥We DO NOT collect any metrics which may contain sensitive data. This includes, but is not limited to: task names, package names, sensitive argument or flag values, environment variables, file paths, or contents of files."
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "注意：此列表会定期审核，以确保其准确性。"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥Note: This list is regularly audited to ensure its accuracy."
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "你可以通过设置以下环境变量来准确查看正在收集的内容：TURBO_TELEMETRY_DEBUG=1。"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥You can view exactly what is being collected by setting the following environment variable: TURBO_TELEMETRY_DEBUG=1."
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "此外，可以通过直接浏览 events 文件来查看所有可能的事件。"
  }, {
    "heading": "收集哪些内容-what-is-collected",
    "content": "¥Additionally, all possible events can be viewed by browsing the events file directly."
  }, {
    "heading": "如何退出-how-do-i-opt-out",
    "content": "¥How do I opt out?"
  }, {
    "heading": "禁用-disable",
    "content": "¥Disable"
  }, {
    "heading": "禁用-disable",
    "content": "你可以通过运行以下命令退出："
  }, {
    "heading": "禁用-disable",
    "content": "¥You may opt out-by running:"
  }, {
    "heading": "禁用-disable",
    "content": "你也可以通过设置以下任意环境变量来退出："
  }, {
    "heading": "禁用-disable",
    "content": "¥You can also opt out by setting any of the following environment variables:"
  }, {
    "heading": "禁用-disable",
    "content": "TURBO_TELEMETRY_DISABLED=1"
  }, {
    "heading": "禁用-disable",
    "content": "DO_NOT_TRACK=1(了解更多关于 控制台禁止跟踪 (DNT) 的信息)"
  }, {
    "heading": "禁用-disable",
    "content": "¥DO_NOT_TRACK=1 (Learn more about Console Do Not Track (DNT))"
  }, {
    "heading": "状态-status",
    "content": "¥Status"
  }, {
    "heading": "状态-status",
    "content": "你可以随时通过运行以下命令检查遥测收集的状态："
  }, {
    "heading": "状态-status",
    "content": "¥You may check the status of telemetry collection at any time by running:"
  }, {
    "heading": "启用-enable",
    "content": "¥Enable"
  }, {
    "heading": "启用-enable",
    "content": "如果你想重新加入该计划，可以运行以下命令重新启用遥测："
  }, {
    "heading": "启用-enable",
    "content": "¥You may re-enable telemetry if you'd like to re-join the program by running the following:"
  }],
  "headings": [{
    "id": "为什么-why",
    "content": "为什么 /*why*/"
  }, {
    "id": "收集哪些内容-what-is-collected",
    "content": "收集哪些内容 /*what-is-collected*/"
  }, {
    "id": "如何退出-how-do-i-opt-out",
    "content": "如何退出？ /*how-do-i-opt-out*/"
  }, {
    "id": "禁用-disable",
    "content": "禁用 /*disable*/"
  }, {
    "id": "状态-status",
    "content": "状态 /*status*/"
  }, {
    "id": "启用-enable",
    "content": "启用 /*enable*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#为什么-why",
  title: _jsx(_Fragment, {
    children: "为什么 "
  })
}, {
  depth: 2,
  url: "#收集哪些内容-what-is-collected",
  title: _jsx(_Fragment, {
    children: "收集哪些内容 "
  })
}, {
  depth: 2,
  url: "#如何退出-how-do-i-opt-out",
  title: _jsx(_Fragment, {
    children: "如何退出？ "
  })
}, {
  depth: 3,
  url: "#禁用-disable",
  title: _jsx(_Fragment, {
    children: "禁用 "
  })
}, {
  depth: 3,
  url: "#状态-status",
  title: _jsx(_Fragment, {
    children: "状态 "
  })
}, {
  depth: 3,
  url: "#启用-enable",
  title: _jsx(_Fragment, {
    children: "启用 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Vercel Inc.（Vercel）可能会收集有关你使用 Turborepo 的遥测数据，如下所述。遥测数据使我们能够通过收集有关 Turborepo 和 Vercel 平台使用情况和主机信息的匿名数据来监控和改进 Turborepo 和 Vercel 平台。这些数据可能用于广泛识别、排除故障或响应影响用户的问题。"
    }), "\n", _jsx(_components.p, {
      children: "¥Vercel Inc. (Vercel) may collect telemetry data about your use of Turborepo as explained below.\nTelemetry data allows us to monitor and improve Turborepo and the Vercel platform by\ncollecting anonymous data about its usage and host information. The data may be used to broadly identify,\ntroubleshoot, or respond to issues that impact users."
    }), "\n", _jsxs(_components.p, {
      children: ["遥测数据的收集是可选的。如果你不想收集遥测数据，你可以禁用 ", _jsx(_components.a, {
        href: "#how-do-i-opt-out",
        children: "opt-out"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Collection of telemetry data is optional. If you do not want telemetry data collected, you may ", _jsx(_components.a, {
        href: "#how-do-i-opt-out",
        children: "opt-out"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "为什么-why",
      children: "为什么 "
    }), "\n", _jsx(_components.p, {
      children: "¥Why"
    }), "\n", _jsx(_components.p, {
      children: "遥测使我们能够准确衡量所有用户的 Turborepo 功能使用情况、痛点和自定义设置。这些数据使我们能够更好地根据大众需求定制 Turborepo，确保其持续增长、相关性和一流的开发者体验。此外，这些数据使我们能够验证改进是否正在改善所有应用的基准。"
    }), "\n", _jsx(_components.p, {
      children: "¥Telemetry allows us to accurately gauge Turborepo feature usage, pain points, and customization across all users.\nThis data enables us to better tailor Turborepo to the masses, ensuring its continued growth, relevance, and best-in-class developer experience.\nFurthermore, this data allows us to verify if improvements are improving the baseline of all applications."
    }), "\n", _jsx(_components.h2, {
      id: "收集哪些内容-what-is-collected",
      children: "收集哪些内容 "
    }), "\n", _jsx(_components.p, {
      children: "¥What is collected"
    }), "\n", _jsx(_components.p, {
      children: "我们跟踪一般使用信息，具体来说，我们使用随机标识符通过匿名遥测数据跟踪以下内容："
    }), "\n", _jsx(_components.p, {
      children: "¥We track general usage information, specifically, we track the following with anonymized telemetry data using random identifiers:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["调用的命令（", _jsx(_components.a, {
            href: "/docs/reference/run",
            children: "turbo run"
          }), "、", _jsx(_components.a, {
            href: "/docs/reference/prune",
            children: "turbo prune"
          }), "、", _jsx(_components.a, {
            href: "/docs/reference/generate",
            children: "turbo gen"
          }), " 等）"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Command invoked (", _jsx(_components.a, {
            href: "/docs/reference/run",
            children: "turbo run"
          }), ", ", _jsx(_components.a, {
            href: "/docs/reference/prune",
            children: "turbo prune"
          }), ", ", _jsx(_components.a, {
            href: "/docs/reference/generate",
            children: "turbo gen"
          }), ", etc.)"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo"
          }), " 版本"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Version of ", _jsx(_components.code, {
            children: "turbo"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "常规机器信息（例如 CPU 数量、macOS/Windows/Linux，以及命令是否在 CI 中运行）"
        }), "\n", _jsx(_components.p, {
          children: "¥General machine information (e.g. number of CPUs, macOS/Windows/Linux, whether or not the command was run within CI)"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "应用大小（工作区总数）"
        }), "\n", _jsx(_components.p, {
          children: "¥Size of application (total number of workspaces)"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "我们不会收集任何可能包含敏感数据的指标。这包括但不限于：任务名称、包名称、敏感参数或标志值、环境变量、文件路径或文件内容。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥We ", _jsx(_components.strong, {
            children: "DO NOT"
          }), " collect any metrics which may contain sensitive data. This includes, but is not limited to: task names, package names, sensitive argument or flag values, environment variables, file paths, or contents of files."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "注意：此列表会定期审核，以确保其准确性。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "Note"
      }), ": This list is regularly audited to ensure its accuracy."]
    }), "\n", _jsxs(_components.p, {
      children: ["你可以通过设置以下环境变量来准确查看正在收集的内容：", _jsx(_components.code, {
        children: "TURBO_TELEMETRY_DEBUG=1"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can view exactly what is being collected by setting the following environment variable: ", _jsx(_components.code, {
        children: "TURBO_TELEMETRY_DEBUG=1"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["此外，可以通过直接浏览 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/crates/turborepo-telemetry/src/events",
        children: "events"
      }), " 文件来查看所有可能的事件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Additionally, all possible events can be viewed by browsing the ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/blob/main/crates/turborepo-telemetry/src/events",
        children: "events"
      }), " file directly."]
    }), "\n", _jsx(_components.h2, {
      id: "如何退出-how-do-i-opt-out",
      children: "如何退出？ "
    }), "\n", _jsx(_components.p, {
      children: "¥How do I opt out?"
    }), "\n", _jsx(_components.h3, {
      id: "禁用-disable",
      children: "禁用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Disable"
    }), "\n", _jsx(_components.p, {
      children: "你可以通过运行以下命令退出："
    }), "\n", _jsx(_components.p, {
      children: "¥You may opt out-by running:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " disable"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "你也可以通过设置以下任意环境变量来退出："
    }), "\n", _jsx(_components.p, {
      children: "¥You can also opt out by setting any of the following environment variables:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "TURBO_TELEMETRY_DISABLED=1"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "DO_NOT_TRACK=1"
          }), "(了解更多关于 ", _jsx(_components.a, {
            href: "https://consoledonottrack.com/",
            children: "控制台禁止跟踪 (DNT)"
          }), " 的信息)"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "DO_NOT_TRACK=1"
          }), " (Learn more about ", _jsx(_components.a, {
            href: "https://consoledonottrack.com/",
            children: "Console Do Not Track (DNT)"
          }), ")"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "状态-status",
      children: "状态 "
    }), "\n", _jsx(_components.p, {
      children: "¥Status"
    }), "\n", _jsx(_components.p, {
      children: "你可以随时通过运行以下命令检查遥测收集的状态："
    }), "\n", _jsx(_components.p, {
      children: "¥You may check the status of telemetry collection at any time by running:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " status"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "启用-enable",
      children: "启用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Enable"
    }), "\n", _jsx(_components.p, {
      children: "如果你想重新加入该计划，可以运行以下命令重新启用遥测："
    }), "\n", _jsx(_components.p, {
      children: "¥You may re-enable telemetry if you'd like to re-join the program by running the following:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " enable"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
